module.exports = __webpack_public_path__ + "img/login_biaoti.6c40879c.png";